// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__l8pS4","col":"Table_col__hN2V5","fulfillmentStatus":"Table_fulfillmentStatus__11ZGu","emailCol":"Table_emailCol__1430z"};